import TimekeepingSchema from "@/store/base/timekeeping/schema";

export default Object.assign({}, TimekeepingSchema, {
  async serialize({dispatch, getters}) {
    const formData = getters['getFormData']

    let days
    await dispatch('serializeDays')
      .then(serializedDays => days = serializedDays || formData.days)

    return {
      uuid: formData?.uuid || undefined,
      employee_uuid: formData.employee_uuid,
      schedule_starts_at: formData.schedule_starts_at,
      schedule_ends_at: formData.schedule_ends_at,
      days,
    }
  },
})

